import { CartAddEvent } from '@theme/events';

class ProductBundle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupBundleItems();
    this.setupAddToCart();
    const radios = document.querySelectorAll('input[name="bundle-purchase-option"]');
    const frequencyBlock = document.querySelector(".subscription-li-text"); 
    
    const updateSubscriptionCheckedClass = () => {
      radios.forEach((radio) => {
        const wrapper = radio.closest(".one-time-purhcase-wrapper, .subscribe-save-wrapper");
        if (wrapper) {
          wrapper.classList.toggle("checked", radio.checked);
        }
      });
    
      const activeValue = document.querySelector('input[name="bundle-purchase-option"]:checked')?.value;
      // frequencyBlock.style.display = activeValue === "subscription" ? "block" : "none";

      const selectSelected = document.querySelector(".select-selected");
      if (selectSelected) {
        if (activeValue === "subscription") {
          selectSelected.classList.remove("disabled");
          frequencyBlock.classList.remove("disabled");
        } else {
          selectSelected.classList.add("disabled");
           frequencyBlock.classList.add("disabled");
        }
      }

    };
    
    // Initial state on load
    updateSubscriptionCheckedClass();
    
    radios.forEach((radio) => {
      radio.addEventListener("change", updateSubscriptionCheckedClass);
    });
  }

  isDrawerOpen() {
    const dialog = document.querySelector(".cart-drawer__dialog");
    return dialog?.hasAttribute("open"); // reliable in Shopify's cart drawer
  }
  

  closeDialog() {
    const dialog = document.querySelector(".cart-drawer__dialog");
    const cartDrawer = document.querySelector("cart-drawer-component");
  
    if (!dialog) return;
  
    const handleBackdropClick = (event) => {
      // if click target IS the dialog itself (the backdrop), not its children
      if (event.target === dialog) {
        cartDrawer?.close?.();
        dialog.removeEventListener("click", handleBackdropClick);
      }
    };
  
    // attach directly to the dialog
    setTimeout(() => {
      dialog.addEventListener("click", handleBackdropClick);
    }, 0);
  }

  setupBundleItems() {
    const bundleItems = this.querySelectorAll("[product-bundle-item]");

    bundleItems.forEach((item) => {
      const radios = item.querySelectorAll('input[type="radio"]');
      const mainContainer = item.querySelector(".main-container")
      const quantityWrapper = item.querySelector(".product-bundle-item__quantity-wrapper");
      const qtyInput = item.querySelector(".product-bundle-item__quantity");
      const footer = item.querySelector(".product-bundle-item__footer");
      const priceValue = item.querySelector(".price-value");
      const minusBtn = item.querySelector(".quantity-btn.minus");
      const plusBtn = item.querySelector(".quantity-btn.plus");
      const comparePriceEl = item.querySelector(".compare-price");
      const priceValueEl = item.querySelector(".price-value");

      let selectedPrice = 0;

      if (mainContainer?.dataset.clickable === "true") {
        mainContainer.style.cursor = "pointer"; // Optional for UX
        mainContainer.addEventListener("click", (e) => {
          const firstRadio = item.querySelector('input[type="radio"]:not(:checked)');
          if (firstRadio) {
            firstRadio.checked = true;
            firstRadio.dispatchEvent(new Event("change", { bubbles: true }));
          }
        });
      }

      radios.forEach((radio) => {
        radio.addEventListener("change", () => {

          const minPriceEl = item.querySelector(".default-min-price");
          if (minPriceEl) minPriceEl.style.display = "none";


          mainContainer.classList.add("selected");
          
          quantityWrapper.style.display = "flex";
          footer.style.display = "block";

          const price = parseFloat(radio.dataset.price || 0);
          const discount = parseFloat(radio.dataset.discount || 0);
          const qty = parseInt(qtyInput.value || 1);

          selectedPrice = price;

          let finalPrice = price;
          if (discount > 0) {
            finalPrice = price * (1 - discount / 100);
            comparePriceEl.style.display = "block";
            comparePriceEl?.classList.add("active")
            comparePriceEl.querySelector(".compare-at").textContent = (
              price * qty
            ).toFixed(2);
          } else {
            comparePriceEl.style.display = "none";
            comparePriceEl?.classList.remove("active")
          }

          priceValueEl.textContent = (finalPrice * qty).toFixed(2);
        });
      });

      // Quantity logic
      const updateQty = () => {
        const quantity = parseInt(qtyInput.value);

        if (!selectedPrice) return;

        if (isNaN(quantity) || quantity < 1) {
          // Reset only this item
          mainContainer.classList.remove("selected");
          
          const minPriceEl = item.querySelector(".default-min-price");
          if (minPriceEl) minPriceEl.style.display = "block";

          quantityWrapper.style.display = "none";
          footer.style.display = "none";
          priceValue.textContent = "0.00";

          qtyInput.value = 1; // ✅ reset quantity to 1
          radios.forEach((r) => (r.checked = false));
          selectedPrice = 0;
        } else {
          const discount = parseFloat(
            item.querySelector('input[type="radio"]:checked')?.dataset
              .discount || 0
          );
          const finalPrice = selectedPrice * (1 - discount / 100);
          priceValue.textContent = (finalPrice * quantity).toFixed(2);

          if (discount > 0) {
            comparePriceEl.style.display = "block";
            comparePriceEl.querySelector(".compare-at").textContent = (
              selectedPrice * quantity
            ).toFixed(2);
          } else {
            comparePriceEl.style.display = "none";
          }
        }
      };

      qtyInput.addEventListener("input", updateQty);

      minusBtn.addEventListener("click", () => {
        qtyInput.value = Math.max(0, parseInt(qtyInput.value || 1) - 1);
        qtyInput.dispatchEvent(new Event("input"));
      });

      plusBtn.addEventListener("click", () => {
        qtyInput.value = parseInt(qtyInput.value || 1) + 1;
        qtyInput.dispatchEvent(new Event("input"));
      });
    });
  }
  setupAddToCart() {
    const atcButton = this.querySelector(".add-to-bag-btn");
    const totalEl = atcButton.querySelector(".bundle-total");

    const updateATC = () => {
        const items = document.querySelectorAll("[product-bundle-item]");
        let totalOneTime = 0;
        let totalSubscription = 0;
        let totalQty = 0;
        let hasAnyItemWithQty3 = false;
      
        const isSubscription = document.querySelector(
          'input[name="bundle-purchase-option"]:checked'
        )?.value === "subscription";
      
        items.forEach((item) => {
          const radio = item.querySelector('input[type="radio"]:checked');
          const qty = parseInt(
            item.querySelector(".product-bundle-item__quantity")?.value || 0
          );
      
          if (radio && qty > 0) {
            const price = parseFloat(radio.dataset.price || 0);
            const discount = parseFloat(radio.dataset.discount || 0);
      
            let basePrice = price * (1 - discount / 100);
            let subPrice = basePrice.toFixed(2) * 0.84;

            totalOneTime += basePrice * qty;
            totalSubscription += subPrice.toFixed(2) * qty;
      
            totalQty += qty;
            if (qty >= 3) hasAnyItemWithQty3 = true;
          }
        });
      
        const atcButton = document.querySelector(".add-to-bag-btn");
        const totalEl = atcButton.querySelector(".bundle-total");
        
      
        // const isEligible = totalQty >= 3 || hasAnyItemWithQty3;
        const isEligible = totalQty >= 1;
      
      
        // ✅ Enable/disable ATC
        atcButton.disabled = !isEligible;
      
        // ✅ Update total
        totalEl.textContent = isSubscription
          ? totalSubscription.toFixed(2)
          : totalOneTime.toFixed(2);
      
        // ✅ Optional: Update preview prices in toggle labels
        const originalPriceSpan = document.querySelector("[original-price-span]");
        const discountedPriceSpan = document.querySelector("[discounted-price-span]");
        const originalPriceWrapper = document.querySelector("[original-price]");
        const discountedPriceWrapper = document.querySelector("[discounted-price]");
        const currencySymbol = document.querySelector("[original-price]")?.textContent.trim().charAt(0) || "£";

        
        if (totalQty > 0) {

          originalPriceWrapper?.classList.remove("hidden");
          discountedPriceWrapper?.classList.remove("hidden");

          if (originalPriceSpan) {
            originalPriceSpan.textContent = `${totalOneTime.toFixed(2)}`;
            originalPriceSpan.style.display = "inline";
          }
          if (discountedPriceSpan) {
            discountedPriceSpan.innerHTML = `<s>${currencySymbol + totalOneTime.toFixed(2)}</s> ${currencySymbol + totalSubscription.toFixed(2)}`;
            discountedPriceSpan.style.display = "inline";
          }
        } else {
          originalPriceWrapper?.classList.add("hidden");
          discountedPriceWrapper?.classList.add("hidden");

          if (originalPriceSpan) originalPriceSpan.style.display = "none";
          if (discountedPriceSpan) discountedPriceSpan.style.display = "none";
        }
      };
      

    // Bind to changes
    this.addEventListener("change", updateATC);
    this.addEventListener("input", updateATC);
    this.addEventListener("click", updateATC);

    atcButton.addEventListener("click", async () => {
      const isSubscription =
        document.querySelector('input[name="bundle-purchase-option"]:checked')
          ?.value === "subscription";
      const selectedPlanName = isSubscription
        ? document.querySelector(".bundle-selling-plan-selector")?.value
        : null;

      const sellingPlanId = isSubscription
        ? document.querySelector(".bundle-selling-plan-selector")?.value
        : null;
      const spinner = atcButton.querySelector(".atc-spinner");
      const label = atcButton.querySelector(".atc-label");

      spinner?.classList.remove("hidden");
      label?.classList.add("hidden");
      
      const itemsToAdd = [];

      this.querySelectorAll("[product-bundle-item]").forEach((item) => {
        const radio = item.querySelector('input[type="radio"]:checked');
        const qty = parseInt(
          item.querySelector(".product-bundle-item__quantity")?.value || 0
        );

        if (radio && qty > 0) {
          let planIdForThisItem = null;

           if (isSubscription && selectedPlanName) {
            try {
              const rawPlanData = item.dataset.sellingPlans;
              if (rawPlanData) {
                try {
                  const plans = JSON.parse(rawPlanData);
                  const matchedPlan = plans.find(plan => plan.name === selectedPlanName);
                  if (matchedPlan) {
                    planIdForThisItem = matchedPlan.id;
                  }
                } catch (e) {
                  console.warn("Invalid selling plan data on item", item, e);
                }
              }
              
            } catch (err) {
              console.warn(`Failed to parse plan data for item`, item, err);
            }
          }

          const itemData = {
            id: radio.value,
            quantity: qty,
            ...(planIdForThisItem && { selling_plan: planIdForThisItem }),
          };

          itemsToAdd.push(itemData);
        }
      });

      if (itemsToAdd.length === 0) return;

      // Get cart section IDs for partial refresh
      const cartItemsComponents = document.querySelectorAll(
        "cart-items-component"
      );
      const sectionIds = Array.from(cartItemsComponents)
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);

      const itemsToAddWithProps = itemsToAdd.map(item => ({
        ...item,
        properties: {
          ...(item.properties || {}),
          "_hidden_item": "true",
        },
      }));

      const body = {
        items: itemsToAddWithProps,
        ...(sectionIds.length > 0 && { sections: sectionIds.join(",") }),
      };

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(body),
        });

        const response = await res.json();
        if (response.sections) {
          for (const [id, html] of Object.entries(response.sections)) {
            const temp = document.createElement("div");
            temp.innerHTML = html;
        
            const newSection = temp.querySelector(`.cart-drawer__dialog`);
            const oldSection = document.querySelector(`.cart-drawer__dialog`);
        
            if (oldSection && newSection) {
              oldSection.replaceWith(newSection);
              // ✅ Re-open if needed
              requestAnimationFrame(() => {
                try {
                  newSection.showModal?.(); // Only call if supported
                } catch (err) {
                  console.warn("[Bundle ATC] showModal() failed:", err);
                }
              });
            }
          }
        }

        if (response.status) {
          console.error("[Bundle ATC] Error:", response.message || "Cart Error");
          return;
        }

        const firstItemId = itemsToAdd[0]?.id || "";
        const itemCount = itemsToAdd.reduce(
          (sum, item) => sum + item.quantity,
          0
        );

        // Dispatch cart update event (triggers cart drawer refresh)
        window.dispatchEvent(
          new CartAddEvent({
            sections: response.sections
          })
        );
        
        try {
          const cartRes = await fetch("/cart.js");
          const cartData = await cartRes.json();
        
          const bubbleText = document.querySelector(".cart-bubble__text");
          const bubbleHidden = document.querySelector(".cart-bubble__text .visually-hidden");
          const cartIcon = document.querySelector("cart-icon");
          const bubble = document.querySelector(".cart-bubble");
        
          const itemCount = cartData.item_count;
        
          if (bubbleText) {
            bubbleText.textContent = itemCount;
            bubbleText.setAttribute("aria-hidden", "false"); // just in case
          }
        
          if (bubbleHidden) {
            bubbleHidden.textContent = `Total items in cart: ${itemCount}`;
          }
        
          if (itemCount > 0) {
            cartIcon?.classList.add("header-actions__cart-icon--has-cart");
            bubble?.classList.remove("visually-hidden");
          } else {
            cartIcon?.classList.remove("header-actions__cart-icon--has-cart");
            bubble?.classList.add("visually-hidden");
          }

          const cartItemComponent = document.querySelector("cart-items-component");
          this.dispatchEvent(
            new CartAddEvent({}, cartItemComponent.dataset.sectionId, {
              didError: false,
              source: "cart-items-component",
              itemCount: itemCount,
              productId: itemsToAdd[0]?.id,
            })
          );

        } catch (e) {
          console.warn("[Bundle ATC] Failed to update cart bubble:", e);
        }
        
        // Open side cart if present
        document.querySelector("cart-drawer-component")?.open?.();
      } catch (err) {
        console.error("[Bundle ATC] AJAX error:", err);
      }finally {
        spinner?.classList.add("hidden");
        label?.classList.remove("hidden");
        this.closeDialog()
      }
    });
  }
}

customElements.define("product-bundle", ProductBundle);
